/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { INosYoutubePlaylistViewProps } from './nos-youtube-playlist';

const NosYoutubePlaylistView: React.FC<INosYoutubePlaylistViewProps> = props => {
    return (
        <section className={props.className}>
            {props.heading}
            {props.thumbnails}
            {props.playerModal}
        </section>
    );
};

export default NosYoutubePlaylistView;
